module.exports = __webpack_public_path__ + "4b026f332a60d4ebedeedf2d7b6fe0db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/26_PROP_BAL_04.png
// module id = 127
// module chunks = 0